export const environment = {
  production: true,
  apiUrl: 'https://qa-ssics-api.azurewebsites.net/api/',
  reportApiUrl: 'https://qa-ssics-reportapi.azurewebsites.net/api/',
  oktaUrl:
    'https://sso-uat.bombardier.com/app/bombardier-uat_smartservicescustomerportal_1/exklzxnabpaWreWan1d7/sso/saml',
};
